export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.48.0-de48ae84e.svg#wishlist-v2-filled","viewBox":"0 0 14 13"}